import React from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import PptxGenJS from 'pptxgenjs';
import domtoimage from 'dom-to-image-more';

function ExportChartToPptButton({ chartIds }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleExport = async (exportType) => {
    if (exportType === 'pptx') {
      const pptx = new PptxGenJS();
      const slideWidth = 10;
      const slideHeight = 5.63;

      for (const chartId of chartIds) {
        const chartElement = document.getElementById(chartId);
        if (!chartElement) {
          console.error(`Chart element with id ${chartId} not found!`);
          continue;
        }

        try {
          const dataUrl = await domtoimage.toPng(chartElement, {
            bgcolor: 'primary.main',
            cacheBust: true,
            quality: 1,
            scale: 2,
          });

          const slide = pptx.addSlide();
          slide.addImage({
            data: dataUrl,
            x: 0,
            y: 0,
            w: slideWidth,
            h: slideHeight,
          });
        } catch (error) {
          console.error(`Error exporting chart with id ${chartId}:`, error);
        }
      }

      await pptx.writeFile({ fileName: 'ChartPresentation.pptx' });
    }
    handleMenuClose();
  };

  return (
    <>
      <IconButton color="primary" onClick={handleMenuClick}>
        <DownloadIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem 
          onClick={() => handleExport('pptx')}
          sx={{ fontSize: '0.9rem' }} // Adjust this value as needed
        >
          Export to PowerPoint (.pptx)
        </MenuItem>
        {/* Additional export options can be added here */}
      </Menu>
    </>
  );
}

export default ExportChartToPptButton;